export class TableRow {
    public isSelected: boolean;
    public isSelectionFreezed: boolean;
    public isEdited: boolean;
    public isNewRow: boolean;
    public cells: {};
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/search/models/table-row.model.ts